import { render } from "./EventViewPrivacyPolicy.vue?vue&type=template&id=3cc08a65&lang=pug"
import script from "./EventViewPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./EventViewPrivacyPolicy.vue?vue&type=script&lang=js"

import exportComponent from "/builds/mfar.technology/events/events-platform/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__